
import ImageMeta from "@/mixins/imageMeta.js";

export default {
  name: "SwiperCarrouselSlide",
  mixins: [ImageMeta],
  props: {
    slide: {
      type: Object,
      default: () => ({}),
    },
    photoSwipeActive: {
      type: Boolean,
      default: false,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFullscreen: false,
      calculatedHeight: 0,
    };
  },
  computed: {
    imageAttributes() {
      return this.getAttribute(this.slide, 'attributes');
    },
    alternativeText() {
      return this.imageAttributes?.alternativeText || 'Image';
    },
    baseHeightOverride() {
      return this.fixedHeight;
    },
    imgClass() {
      return this.fixedHeight
        ? 'h-64 w-full'
        : this.isFullscreen
          ? 'w-full object-cover'
          : 'w-full object-contain';
    },
  },
  mounted() {
    this.checkFullscreen();
    this.calculateHeight();
    window.addEventListener('resize', this.calculateHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateHeight);
  },
  methods: {
    checkFullscreen() {
      this.isFullscreen = window.innerWidth >= 1024;
    },
    calculateHeight() {
      this.checkFullscreen();
      this.$nextTick(() => {
        const bodyRect = document.body.getBoundingClientRect();
        const carouselTop = this.$el.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;
        const additional = this.isFullscreen ? 40 : 20
        this.calculatedHeight = viewportHeight - carouselTop - additional;
      });
    },
  },
};
